import React from 'react';

const Card = ({ children}) => {
    return (
        <div className="writing__template__card">
           { children} 
        </div>
    );
}

export default Card;
